import { ReactNode } from 'react';

/**
 * Interrupteur toggle — remplace MUI Switch.
 */
const Switch = (props: {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: ReactNode;
    disabled?: boolean;
}) => (
    <button
        type="button"
        role="switch"
        aria-checked={props.checked}
        disabled={props.disabled}
        onClick={() => props.onChange(!props.checked)}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200
            focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--eb-primary)]/40
            disabled:opacity-50 disabled:cursor-not-allowed
            ${props.checked ? 'bg-[var(--eb-primary)]' : 'bg-[var(--eb-border)]'}`}
    >
        <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform duration-200
                ${props.checked ? 'translate-x-6' : 'translate-x-1'}`}
        />
        {props.label && <span className="ml-2 text-sm text-[var(--eb-text)]">{props.label}</span>}
    </button>
);

export default Switch;
